import Modal from 'bootstrap/js/dist/modal';
import Tooltip from 'bootstrap/js/dist/tooltip';

class Wishlist {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('[data-wishlist-button]');
        self.modalContent = document.querySelector('[data-wishlist-modal-content]');
        self.modal = new Modal('[data-wishlist-modal]');
        self.spinner = document.querySelector('[data-wishlist-modal-spinner]');
        self.wishlistButton = document.querySelector('[data-wishlist-button]');
    }

    init() {
        let self = this;

        self.setWishlistButtonCount();

        self.trigger.addEventListener('click', evt => {

            // Empty the modal content
            self.modalContent.textContent = '';

            // Show the spinner
            self.spinner.classList.remove('d-none');

            // Show the modal
            self.modal.show();

            // Get the wishlist data
            self.getWishlist();
        });
    }

    setWishlistButtonCount() {
        let self = this;
        let endpoint = '/index.php?p=actions/site/wishlist/count';
        let wishlistButtonCountElem = document.querySelector('[data-wishlist-button-count]');

        fetch(endpoint, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            if (data.response === 'success') {
                wishlistButtonCountElem.textContent = data.count;

                if(data.count > 0) {
                    self.trigger.classList.add('has-items');
                }
            }

        }).catch(function (err) {
            // There was an error
            console.warn('Could not fetch wishlist count', err);
        });
    }

    getWishlist() {
        let self = this;

        fetch('/wishlist-ajax', {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function (response) {
            // The API call was successful!
            return response.text();
        }).then(function (html) {
            // Hide the spinner
            self.spinner.classList.add('d-none');

            // Add the wishlist HTML to the modal
            self.modalContent.innerHTML = html;

            // Store references to elements within HTML
            self.wishlistItems = document.querySelectorAll('[data-wishlist-item]');
            self.wishlistItemsCount = self.wishlistItems.length;
            self.noItemsMessage = document.querySelector('[data-wishlist-no-items]');
            self.shareElem = document.querySelector('[data-wishlist-share]');
            self.shareForm = document.querySelector('[data-wishlist-share-form]');
            self.sendButton = document.querySelector('[data-wishlist-send]');
            self.sendAndClearButton = document.querySelector('[data-wishlist-send-and-clear]');
            self.sendSuccessMessage = document.querySelector('[data-wishlist-share-success-message]');
            self.clearAllForm = document.querySelector('[data-wishlist-clear-all-form]');

            // Handle removals
            self.handleRemovals();

            // Handle sharing
            self.handleSharing();

        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        });
    }

    handleRemovals() {
        let self = this;

        [...self.wishlistItems].map(item => {
            // Get some elements
            let form = item.querySelector('[data-wishlist-item-remove-form]');
            let button = item.querySelector('[data-wishlist-item-remove-button]');

            // Instantiate tooltips on the remove buttons
            let tooltip = Tooltip.getOrCreateInstance(button);

            button.addEventListener('click', evt => {
                // Get the data from the wishlist removal form
                let formData = new FormData(form);

                // Remove the item from the wishlist
                fetch('/', {
                    method: 'post',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }).then(function(response) {
                    response.json().then(function(data) {
                        // Fade out the item
                        item.classList.add('is-removed');

                        // Stuff to do once the fade out transition is complete
                        let func = function() {
                            // Remove the item from the DOM
                            item.remove();

                            // Decrement the wishlist item count
                            self.wishlistItemsCount--;

                            // Decrement the item count on the wishlist button in the header
                            self.updateWishlistButtonCount();

                            // Uncheck the checkbox next to the corresponding collection item (if it exists on the current page)
                            self.uncheckRemovedItem(formData.get('elementId'));

                            // If this is the last item in the wishlist, show the 'no items' message
                            if(self.wishlistItemsCount < 1) {
                                self.noItemsMessage.classList.remove('d-none');
                                self.shareElem.classList.add('d-none');
                            }
                        }

                        // Remove the button's tooltip
                        tooltip.dispose();

                        // Remove the item from the DOM
                        item.addEventListener('transitionend', func, false);
                    });
                });
            });
        });
    }

    handleSharing() {
        let self = this;

        self.sendButton.addEventListener('click', evt => {
            self.submitForm(self.sendButton, false);     
        });

        self.sendAndClearButton.addEventListener('click', evt => {
            self.submitForm(self.sendAndClearButton, true);      
        });
    }

    submitForm(button, clearForm) {
        let self = this;

        // Get form data
        let formData = new FormData(self.shareForm);
        let buttonText = button.textContent;

        // Check form vailidity
        if(self.shareForm.reportValidity()) {
            // Get form data
            let formData = new FormData(self.shareForm);

            button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending...';

            // Submit the form
            fetch('/', {
                method: 'post',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then(function(response) {
                response.json().then(function(data) {

                    function onSubmitFunc() {
                        // Show success message
                        self.sendSuccessMessage.classList.remove('d-none');

                        // Scroll to the success message
                        self.sendSuccessMessage.scrollIntoView();

                        // Clear the form
                        self.shareForm.reset();

                        // Reset the button text
                        button.textContent = buttonText;
                    };

                    // Clear wishlist
                    if(clearForm) {
                        self.clearWishlist(onSubmitFunc);
                    } else {
                        onSubmitFunc();
                    }
                });
            });
        }
    }

    updateWishlistButtonCount() {
        let self = this;

        let wishlistButtonCountElem = document.querySelector('[data-wishlist-button-count]');

        if(self.wishlistItemsCount === 0) {
            self.wishlistButton.classList.remove('has-items');
        } else {
            self.wishlistButton.classList.add('has-items');
        }

        wishlistButtonCountElem.textContent = self.wishlistItemsCount;
    }

    uncheckRemovedItem(id) {
        let self = this;

        let checkbox = document.querySelector(`[data-wishlist-checkbox="${id}"]`);

        if(checkbox) {
            checkbox.checked = false;
        }
    }

    clearWishlist(callback) {
        let self = this;

        // Get the form data
        let formData = new FormData(self.clearAllForm);

        // Submit the form
        fetch('/', {
            method: 'post',
            body: formData,
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function(response) {
            response.json().then(function(data) {
                // Remove wishlist items from the DOM
                self.removeAllWishlistItems();

                // Show 'no items' message
                self.noItemsMessage.classList.remove('d-none');

                // Hide the share elements
                self.shareElem.classList.add('d-none');

                // Set wishlist item count to zero
                self.wishlistItemsCount = 0;

                // Set the item count on the wishlist button in the header to zero
                self.updateWishlistButtonCount();

                // Uncheck all checkboxes on the page
                self.uncheckAllItems();

                // Execute callback function (everything else we need to do after clearing the list)
                callback();
            });
        });
    }

    removeAllWishlistItems() {
        let self = this;

        let wishlistItems = document.querySelectorAll('[data-wishlist-item]');

        [...wishlistItems].map(item => {
            item.remove();
        });
    }

    uncheckAllItems() {
        let self = this;

        let checkboxes = document.querySelectorAll('[data-wishlist-checkbox]');

        [...checkboxes].map(checkbox => {
            checkbox.checked = false;
        });
    }
}

export default Wishlist;